import React from 'react';
import sxcschol from '../img/2.avif';

export default function About() {
  // Indian school classroom image
  
  return (
    <div id="about" className="container-fluid py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5">
            <img className="img-fluid rounded mb-5 mb-lg-0" src={sxcschol} alt="About" style={{objectFit:'cover'}} />
          </div>
          <div className="col-lg-7">
            <p className="section-title pr-5"><span className="pr-2">About Our School</span></p>
            <h1 className="mb-4">Your Child's Gateway to Excellence</h1>
            <p>
              St. Francis Xavier's Higher Secondary School, is a Jesuit school located in Tuticorin, in Tamil Nadu, India. The school is administered by the Madurai Province of the Society of Jesus. Founded in 1884, it is the oldest school in Tuticorin. It is named after the Jesuit missionary, St. Francis Xavier (1506-1552).
            </p>
            <a href="#classes" className="btn btn-primary mt-2 py-2 px-4">View Our Programs</a>
          </div>
        </div>
      </div>
    </div>
  );
}
